import request from "@/utils/request";
import requestCache from "@/utils/requestWithCache";

export function getColors(params) {
  return requestCache({
    url: "/api/admin/banners/colors/",
    method: "get",
    params,
  });
}
export function getColorById(colorId) {
  return request({
    url: `/api/admin/banners/colors/${colorId}/`,
    method: "get",
  });
}
export function createColor(data) {
  return request({
    url: `/api/admin/banners/colors/`,
    method: "post",
    data,
  });
}
export function deleteColor(colorId) {
  return request({
    url: `/api/admin/banners/colors/${colorId}/`,
    method: "delete",
  });
}
export function updateColor(colorId, data) {
  return request({
    url: `/api/admin/banners/colors/${colorId}/`,
    method: "patch",
    data,
  });
}
